import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import { ToWords } from "to-words";
import Moment from "react-moment";
import ShowSingleMeasurement from "../Measurement/ShowSingleMeasurement";
import ShowSingleMeasurementPrint from "./../Measurement/ShowSingleMeasurementPrint";
// import Barcode from "react-barcode";
import {
  addOrderInfo,
  clearOrderProductItemStore,
  assignOrderProductItemListStore,
  addOrderProductItemStoreAtBottom,
  removeOrderProductItemStore,
  //** OrderItemDetailStoreForPrint */
  assignOrderItemDetailStoreForPrint,
  clearOrderItemDetailStoreForPrint,
  addOrderItemDetailStoreForPrint,
  removeOrderItemDetailStoreForPrint,
  //** */
  clearOrder,
  clearOrderItemDetailStore,
  updateOrderInfoModeStore,
  addOrderItemDetailStore,
  addOrderItemDetailStoreAtBottom,
  removeOrderItemDetailStore,
  addOrderItemWithMeasurementsStore,
  removeOrderItemWithMeasurementsStore,
  addOrderItemUniqueStore,
  removeOrderItemUniqueStore,
  updateViewModeOrderItemDetailStore,
} from "./../../slice/orderSlice";
import commonServices from "../../Utils/commonServices";
import BarcodeCustomed from "./../Common/BarcodeCustomed";
import { clear } from "@testing-library/user-event/dist/clear";
import useTranslation from "./../../customHooks/translations";

const OrderMakingPrint = (props) => {
  const translation = useTranslation();
  // var totalAmount = 0;
  const [orderDetailID, setOrderDetailID] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [qtyOfITem, setQtyOfITem] = useState(1);
  const [qtyOfITemArray, setQtyOfITemArray] = useState([]);
  const rows = [];

  const dateNow = new Date();
  const current = new Date();
  const dateToday = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Taka",
        plural: "Taka",
        symbol: "tk",
        fractionalUnit: {
          name: "Poisa",
          plural: "Poisa",
          symbol: "",
        },
      },
    },
  });

  //*** Store */
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderProductItemStore,
    orderItemsWithMeasurementStore,
    orderItemDetailStoreForPrint,
    isLoadingStore,
  } = useSelector((state) => state.order);

  useEffect(() => {
    dispatch(
      assignOrderItemDetailStoreForPrint(props.orderItemDetailStoreProp)
    );

    let filteredOrderDetail = orderProductItemStore.filter((pi) => {
      return pi.orderDetailID_GUID === props.orderDetailID_GUID_props;
    });

    setOrderDetailID(filteredOrderDetail[0]?.orderDetailID);

    console.log(
      " filteredOrderDetail ===========> " +
        filteredOrderDetail[0]?.qty +
        JSON.stringify(orderProductItemStore)
    );

    // setQtyOfITemArray
    for (let i = 0; i < parseInt(filteredOrderDetail[0]?.qty); i++) {
      // setQtyOfITemArray(qtyOfITemArray.push({i}));
      rows.push({ i });
    }

    setQtyOfITemArray(rows);
    console.log("rows   " + JSON.stringify(rows));
  }, [props.orderItemDetailStoreProp]);

  //*** Barcode Related */
  const [barcodetext, setBarcodetext] = useState("");
  const setBarcodeItemTrackingNo = (orderDetailID) => {
    // alert("orderDetailID : " + orderDetailID);
    setBarcodetext(orderDetailID);
  };

  return (
    <Fragment>
      <div className="print_1 ">
        {/* <div className="left">
        {qtyOfITemArray?.map((counter) => {
          return barcodetext && <Barcode value={barcodetext} height={40} />;
        })}
      </div> */}
        <div className="left">
          <BarcodeCustomed
            orderNumber={props.orderStore?.orderID}
            orderDeailID={orderDetailID}
            trackingNumber={barcodetext}
            className="floatLeft"
            height={50}
          />
          <BarcodeCustomed
            orderNumber={props.orderStore?.orderID}
            orderDeailID={orderDetailID}
            trackingNumber={barcodetext}
            className="floatLeft"
            height={50}
          />
          <BarcodeCustomed
            orderNumber={props.orderStore?.orderID}
            orderDeailID={orderDetailID}
            trackingNumber={barcodetext}
            className="floatLeft"
            height={50}
          />
          <BarcodeCustomed
            orderNumber={props.orderStore?.orderID}
            orderDeailID={orderDetailID}
            trackingNumber={barcodetext}
            className="floatLeft"
            height={50}
          />
          <BarcodeCustomed
            orderNumber={props.orderStore?.orderID}
            orderDeailID={orderDetailID}
            trackingNumber={barcodetext}
            className="floatLeft"
            height={50}
          />
          <div style={{ clear: "both" }}></div>

          {/* <Barcode value={barcodetext} height={50} />
          <Barcode value={barcodetext} height={50} />
          <Barcode value={barcodetext} height={50} />
          <Barcode value={barcodetext} height={50} />
          <Barcode value={barcodetext} height={50} /> */}
        </div>
        {/* <hr /> */}
        <div className="col-lg-12 margin_padding_zero">
          <div className="card padding-Zero-Important margin-Zero-Important">
            <div className="card-body padding-Zero-Important margin-Zero-Important">
              <div className="table-responsive">
                {/* <table
                  className="measurePrintHeaderTable"
                  style={{ width: "100%" }}
                >
                  <tr>
                    <td style={{ width: "30%" }}>
                      <div>
                        <b>Customer Name:</b> {props.customerStore?.name} <br />
                        <b>Phone no:</b> {props.customerStore?.cellNo} <br />
                      </div>
                    </td>
                    <td style={{ width: "30%" }}>
                      <div style={{ textAlign: "center" }}>
                        <b>Order Number: {props.orderStore?.orderID}</b>
                        <br />
                        <b> লিবাস টেইলার্স</b>
                        <br />
                      </div>
                    </td>
                    <td style={{ width: "30%" }}>
                      <div>
                        <b>Order Date: </b>
                        {/* {dateToday} */}
                {/* {
                        <Moment format=" Do MMMM YYYY, h:mm:ss a">
                          {dateNow}
                        </Moment>
                      } /}
                        {commonServices.showDateRemovedT(
                          props.orderStore?.orderDate
                        )}
                        <br />
                        <b>Delivery Date: </b>
                        {/* {dateToday} /}
                        {/* {<Moment format=" Do MMMM YYYY">{dateNow}</Moment>} /}
                        {commonServices.showDateRemovedT(
                          props.orderStore?.deliveryDate
                        )}
                      </div>
                    </td>
                  </tr>
                </table> */}

                <table
                  className="measurePrintHeaderTable"
                  style={{
                    width: "100%",
                    border: "1px solid black",
                    marginTop: "5px",
                  }}
                >
                  <tr>
                    <td style={{ width: "20%" }}>
                      <div>
                        <b>{translation.Phone}:</b>{" "}
                        {props.customerStore?.cellNo}
                      </div>
                    </td>
                    <td style={{ width: "40%" }}>
                      <div style={{ textAlign: "center" }}>
                        <b>লিবাস টেইলার্স</b> &nbsp;&nbsp;&nbsp;{" "}
                        <b>
                          {translation.Order_No}: {props.orderStore?.orderID}
                        </b>
                      </div>
                    </td>
                    <td style={{ width: "40%" }}>
                      <div>
                        <b>O. Date: </b>
                        {commonServices.showDateRemovedT(
                          props.orderStore?.orderDate
                        )}
                        &nbsp;&nbsp;&nbsp;
                        <b>D. Date: </b>
                        {/* {dateToday} */}
                        {/* {<Moment format=" Do MMMM YYYY">{dateNow}</Moment>} */}
                        {commonServices.showDateRemovedT(
                          props.orderStore?.deliveryDate
                        )}
                      </div>
                    </td>
                  </tr>
                  {/* <tr>
                    <td colSpan={3}>
                      <div>
                        <b>Customer Name:</b> {props.customerStore?.name}
                      </div>
                    </td>
                  </tr> */}
                </table>

                {/* ///  *** orderItemDetailStoreProp   -- For Print..... */}
                <div className="read-content">
                  {/* New coding */}
                  {/* {orderItemDetailStoreForPrint.map((orderDetail, i) => { */}
                  {props.orderItemDetailStoreProp?.map((orderDetail, i) => {
                    return (
                      <ShowSingleMeasurementPrint
                        customerName={props.customerStore?.name}
                        customerStoreProps={props.customerStore}
                        orderStoreProps={props.orderStore}
                        orderDetailID_GUID_props={
                          orderDetail.orderDetailID_GUID
                        }
                        indexEntry={orderDetail.indexNo}
                        lstMeasurementDetail={orderDetail.lstMeasurementDetails}
                        orderProductItemStore={orderProductItemStore}
                        setBarcodeItemTrackingNo={setBarcodeItemTrackingNo}
                        comment={orderDetail.qty}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OrderMakingPrint;
